import * as React from 'react'
import { Link } from 'react-router-dom'
import './index.scss'

const MenuItem: React.SFC<any> = ({ content, route, isButton, isExternal, link, newTab }) => {
    return (
        <li className={isButton ? "decode-item decode-item--button" : "decode-item" }>
            {
                !isExternal ? <Link to={route}>{content}</Link> : <a href={ link } target={ newTab === true ? "_blank" : "_self" }>{ content }</a>
            }
        </li>
    )
}

export default MenuItem



// WEBPACK FOOTER //
// ./src/components/common/MenuItem/index.tsx